import { createContext, useState } from 'react';
import api from 'services/api';

export const AgendaContext = createContext();

export const AgendaProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);

  const getAgendas = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/Cadastros/Tarefa', { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postAgendas = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post('/Comercial/Agenda', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  return (
    <AgendaContext.Provider
      value={{ getAgendas, getLoading, postAgendas, postLoading }}
    >
      {children}
    </AgendaContext.Provider>
  );
};
